<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Administración De Solicitud De Inclusiones, Exclusiones Y Cancelaciones
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Póliza" color="textbox" v-model="objSearch.idPoliza"
                            @change="onListarSolicitudes" :items="listGeneral.listPoliza" item-value="idPoliza"
                            item-text="poliza" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo Solicitud" color="textbox" v-model="objSearch.idTipoSolicitud"
                            @change="onListarSolicitudes" :items="listGeneral.listSolicitud" item-value="idSolicitud"
                            item-text="solicitud" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado" color="textbox" v-model="objSearch.idEstado"
                            :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado"
                            @change="onListarSolicitudes" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                            :return-value.sync="objSearch.fechaDesde" persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaDesde" label="Fecha Desde"
                                    :rules="requeridoRegla" prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaDesde" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false"
                                    v-text="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaDesde.save(objSearch.fechaDesde); onListarSolicitudes('L')"
                                    v-text="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                            :return-value.sync="objSearch.fechaHasta" persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaHasta" label="Fecha Hasta"
                                    :rules="requeridoRegla" prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaHasta" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false"
                                    v-text="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaHasta.save(objSearch.fechaHasta); onListarSolicitudes('L')"
                                    v-text="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-btn v-show="_.size(listGeneral.detalle) > 0" rounded dark color="primary" :disabled="disabled" @click="insertarActualizar">Guardar</v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <modalPDFComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearch.search" :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                            class="elevation-3">
                            <template v-slot:item.pdf="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="onVerPdf(item)">
                                    <v-icon>visibility</v-icon>
                                </v-btn>                                
                            </template>
                            <template v-slot:item.name="{ item }">
                                <v-checkbox v-model="item.rechazar" dense />
                            </template>
                            <template v-slot:pageText="props">
                                Registro del <span v-text="props.pageStart"></span> al <span
                                    v-text="props.pageStop"></span>
                                de <span v-text="props.itemsLength"></span>
                            </template>
                            <template v-slot:no-results>
                                <v-alert :value="true" color="blue" icon="info">Tu búsqueda de "<span
                                        v-text="search"></span>" no arrojó resultados.</v-alert>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        components: {
            modalPDFComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        name:'AdministracionSolicitudView',
        data: () => ({
            listGeneral: [],
            disabled: false,
            listParametros: [],
            objPdf:{
                mostrar: false,
                titulo: '',
                base64: ''
            },
            objDate:{
                desde: { abrirModal: false },
                hasta: { abrirModal: false }
            },
            objSearch: {
                opcion: 'LISTAR_SOLICITUD',
                search: '',
                idPoliza: null,
                fechaDesde: moment().format('YYYY-MM-DD'),
                fechaHasta: moment().format('YYYY-MM-DD'),
                idEstado: null
            }
        }),
        created(){
            axios.post(`${BASE_URI}administrador/t-inclusion-exclusion-accesorio/cargaGeneral`,{})
                 .then((r) =>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0 ) throw mensajeEstandar.errorPeticion;
                        this.listGeneral = r.data.data.listas;
                        this.listParametros = r.data.data.parametro;
                        this.objSearch.idEstado = _.toString(this.listParametros.idEstadoDefault);
                        this.listGeneral.listEstadoSolicitud = _.filter(this.listGeneral.listEstadoSolicitud, (v) => { return _.isEqual(v.visualiza,'true') }); 
                        this.objSearch.idTipoSolicitud = (_.find(this.listGeneral.listSolicitud, (v) => { return v.visualiza == 'true'  })).idSolicitud;
                        this.onCargaGeneral();
                 })
                 .catch((e)=>{  
                     mensajesAlerta(e,'E');
                 });
        },
        methods: {
            apiSend(ruta,objeto){
                return axios.post(`${BASE_URI}${ruta}`,objeto);
            },
            onCargaGeneral(){
                this.objSearch.idPoliza = this.listGeneral.listPoliza[0].idPoliza; 
                this.onListarSolicitudes('L');
            },
            onListarSolicitudes(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var objeto = _.clone( this.objSearch);
                    objeto.idEstado        = objeto.idEstado == 0 ? null : objeto.idEstado;
                    objeto.idTipoSolicitud = objeto.idTipoSolicitud == 0 ? null : objeto.idTipoSolicitud;
                    
                    this.$set(this.listGeneral,'detalle',[]);
                    return this.apiSend('administrador/t-inclusion-exclusion-accesorio/listar',objeto)
                                .then((respuesta) => {
                                    if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                    if(_.size(respuesta.data.data) == 0){ error= 'I'; throw respuesta.data.mensaje; }
                                        var l =  _.chain(_.cloneDeep(respuesta.data.data))
                                                  .groupBy('index')
                                                  .mapValues(_.partial(_.map, _, 'descripcion'))
                                                  .value();
                                        
                                        var lista = _.map(_.cloneDeep(respuesta.data.data),(v)=>{ 
                                                                                            v.rechazar    = parseInt(v.rechazar) == 1 ? true : false; 
                                                                                            v.check       = v.rechazar; 
                                                                                            v.idSolicitud = v.index;
                                                                                            var ll = _.filter(l,(vv,k)=>{ return parseInt(k) == parseInt(v.index); });
                                                                                            v.descripcion = _.join(_.get(ll,'0'),'*');
                                                                                            return v; 
                                                                                    });
                                        
                                        this.$set(this.listGeneral,'detalle',_.uniqBy(lista,'index'));
                                })
                                .catch((e) => {
                                    mensajesAlerta(e,error);
                                });
                }
            },
            onVerPdf(objeto){
                this.apiSend('administrador/repository-file/listar',{'path': objeto.ruta})
                        .then((respuesta) => {
                            if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                            
                                this.objPdf.base64 = JSON.parse(JSON.stringify(respuesta.data.data));
                                this.objPdf.titulo = 'Solicitud de '+objeto.tipoSolicitud;
                                this.objPdf.mostrar = true;
                        })
                        .catch((e) => {
                            mensajesAlerta(e,'E');
                        });
            },
            insertarActualizar(){
                try {
                    var lista = _.filter(this.listGeneral.detalle,(v) => { return v.check != v.rechazar; });
                    var keys = ['idSolicitud','idCertificado','idPoliza','idTipoSolicitud','rechazar','idEstado','idEstadoSolicitud'];
                    lista = _.map(lista,_.partialRight(_.pick,keys));

                    if(_.size(lista) == 0) throw 'No realizo cambio en alguna solicitud';      
                        this.disabled = true;
                        var error = 'E';
                        return this.apiSend('administrador/t-inclusion-exclusion-accesorio/rechazar-solicitud',{ opcion: 'U',  listSolicitudes: lista })
                                    .then((respuesta) => {
                                        if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                        if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                        if(_.size(respuesta.data.data) == 0) { error = 'I'; throw respuesta.data.mensaje;}
                                            this.disabled = false;
                                            this.onListarSolicitudes('L');
                                    })
                                    .catch((e) => {
                                        this.disabled = false;
                                        mensajesAlerta(e,error);
                                    });
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide() {
            return {
                cerrarModalPdf : this.cerrarModalPdf
            }
        }
    }
</script>